module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dV9sH"))).then(() => parcelRequire('fThBo'));